// extracted by mini-css-extract-plugin
export default {"btop":"e3e52a31b2 _7ed3c3804f _4bd9aa24e3","icon":"aad67b9397 _30c9d88dce","btoppink":"bbde66c967 e6f377fd77"};